import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';

export default function useIsInQualiExperiment(): boolean {
  return useExperimentBucket('quali-srp-carvanads') === 'survey';
}
